import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-card-with-footer',
  templateUrl: './card-with-footer.component.html',
  styleUrls: ['./card-with-footer.component.css']
})
export class CardWithFooterComponent implements OnInit {

  @Input() cardInfo;
  
  constructor() { }

  ngOnInit(): void {
  }

}
